export const LAB_PARTNER_MIN_PAYOUT = 10;

export function parseAccruedTotal(partner) {
  if (!partner || partner.accrued_total == null) {
    return 0;
  }

  const value = parseFloat(partner.accrued_total);
  return Number.isFinite(value) ? value : 0;
}

export function isAccruedAboveThreshold(partner, threshold = LAB_PARTNER_MIN_PAYOUT) {
  return parseAccruedTotal(partner) >= threshold;
}

export function filterPayoutCandidates(partners, threshold = LAB_PARTNER_MIN_PAYOUT) {
  if (!Array.isArray(partners)) {
    return [];
  }

  return partners.filter(function (partner) {
    return partner.status === 'active'
      && partner.user_id
      && isAccruedAboveThreshold(partner, threshold);
  });
}

export function setAuthHeader(axiosInstance, cookieModel) {
  axiosInstance.defaults.headers.common.Authorization = 'Bearer ' + cookieModel.getCookie('ticketlab_access');
}

export function fetchLabPartners(axiosInstance, baseUrl, params = {}) {
  return axiosInstance.get(baseUrl + '/admin/referral-partners', { params });
}

export function fetchLabPartner(axiosInstance, baseUrl, partnerId) {
  return axiosInstance.get(baseUrl + '/admin/referral-partners/' + partnerId);
}

export function fetchPayoutPreview(axiosInstance, baseUrl, partnerId, dateFrom, dateTo) {
  return axiosInstance.get(baseUrl + '/admin/referral-partners/' + partnerId + '/payout-preview', {
    params: {
      date_from: dateFrom,
      date_to: dateTo,
    },
  });
}

export function generatePayoutInvoice(axiosInstance, baseUrl, partnerId, payload) {
  return axiosInstance.post(baseUrl + '/admin/referral-partners/' + partnerId + '/generate-payout-invoice', payload);
}

export function markReferralPayoutPaid(axiosInstance, baseUrl, invoiceId, payload = {}) {
  return axiosInstance.post(baseUrl + '/admin/referral-invoices/' + invoiceId + '/mark-paid', payload);
}

export function sendReferralPayoutInvoice(axiosInstance, baseUrl, invoiceId) {
  return axiosInstance.post(baseUrl + '/admin/referral-invoices/' + invoiceId + '/send');
}
